"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 产品管理模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/productInfo/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetails: function getDetails(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/productInfo/query/' + id,
      method: 'post'
    });
  }
};